import React from 'react';

function link_1() {
  return <a href="http://www.scholarpedia.org/article/Echo_state_network" target="_blank" rel="noopener noreferrer">1</a>
}
function link_2() {
  return <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2924583/" target="_blank" rel="noopener noreferrer">2</a>
}
function link_3() {
  return <a href="https://arxiv.org/abs/2007.09309" target="_blank" rel="noopener noreferrer">3</a>
}

function Abstract() {
  return (
    <div className="row">
      <div className="w-100">
        <p>
          The dynamics of physiological systems are significantly impacted by delay.
          The time-delay caused by the transport and processing of chemical components and signals may be of significant consequence.
          Biological systems present a challenge to model, analyze and predict.
        </p>
        <p>
          The utilization of machine learning to build mathematical models of complex systems has rapidly grown.
          For time-dependent series, generally a <strong>recurrent neural network</strong> (RNN), capable of returning past states, is used.
          In most common RNN implementations, multiple hidden layers are rebalanced during training to achieve adequate results.
          However, these implementations can be computationally expensive and may require extensive training data.
        </p>
        <p>
          Here, we utilize a type of RNN called an <strong>echo state network</strong><sup>[{ link_1() }]</sup> (ESN), a static, randomly initialized reservoir of nodes.
          We study two types of physiological systems exhibiting delay: <strong>degrade-and-fire</strong><sup>[{link_2()}]</sup> circuits and the <strong>insulin-glucose</strong><sup>[{ link_3() }]</sup> cycle.
          Manipulating only signal propagation and input smoothing, we model both systems with generated reservoirs.
        </p>
     </div>
   </div>
  );
}

export default Abstract;
